import React, { useEffect, useState } from "react";
import i18n from "../i18n.js";
import { connect } from "react-redux";
import Header from "../utility/components/frontend/Header";
import Footer from "../utility/components/frontend/Footer";
import {
  fetchSiteSettingsByKeys,
  PUBLIC_SITE_SETTING_KEYS,
} from "../utility/services/siteSettingsService";

const DefaultLayout = ({ children }) => {
  const [lightBackground, setLightBackground] = useState(false);
  const [siteSettings, setSiteSettings] = useState({});

  const themeEnable = () => {
    setLightBackground(true);
  };

  const themeDisable = () => {
    setLightBackground(false);
  };

  useEffect(() => {
    fetchSiteSettingsByKeys(PUBLIC_SITE_SETTING_KEYS)
      .then(setSiteSettings)
      .catch(() => setSiteSettings({}));
  }, []);

  return (
    <div className={`${lightBackground === true ? "light-theme" : ""} ${i18n.language === "en" ? "" : ""}`}>
      <Header
        themeEnable={themeEnable}
        themeDisable={themeDisable}
        siteSettings={siteSettings}
      />
      <div>{children}</div>
      <Footer siteSettings={siteSettings} />
    </div>
  );
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {})(DefaultLayout);
